import { useMutation, useQuery, useQueryClient, type UseQueryResult } from '@tanstack/react-query';
import {
  EOD_CLOSE_QUERY_KEY,
  getStageForEodLog,
  listEodEligibleStages,
  submitEodCloseBatch,
  type EodEligibleFilters,
} from '@/services/eodClose.service';
import { MFG_EXECUTION_BOARD_QUERY_KEY } from '@/services/workOrderExecutionBoard.service';
import type { EodCloseStageInput, EodCloseStageResult, EodEligibleStage } from '@/utils/eodClose';

export function useEodEligibleStages(
  filters: EodEligibleFilters,
  enabled = true
): UseQueryResult<EodEligibleStage[], Error> {
  return useQuery({
    queryKey: [EOD_CLOSE_QUERY_KEY, 'eligible', filters],
    queryFn: () => listEodEligibleStages(filters),
    enabled,
  });
}

export function useEodCloseMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (items: EodCloseStageInput[]) => submitEodCloseBatch(items),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [EOD_CLOSE_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [MFG_EXECUTION_BOARD_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: ['work-order-stages'] });
    },
  });
}

export function useEodStageLog(stageId: string | null, enabled = false) {
  return useQuery({
    queryKey: [EOD_CLOSE_QUERY_KEY, 'stage-log', stageId],
    queryFn: () => getStageForEodLog(stageId!),
    enabled: enabled && !!stageId,
  });
}

export type { EodCloseStageResult };
